// extracted by mini-css-extract-plugin
export default {"FormContainer":"LanguageForm_FormContainer__tYoYq"};